import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches all approver roles from the backend
 * @returns {Promise<Array>} - Array of approver roles
 */
export const getApproverRoles = async () => {
  try {
    const response = await apiClient.get('/adminInvoiceManagement/approver-roles');

    // Handle the response structure: { status: 200, message: "...", response: [...] }
    if (response.data && response.data.response) {
      return response.data.response;
    } else if (response.data && Array.isArray(response.data)) {
      // Fallback: if response.data is directly an array
      return response.data;
    }

    return [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
